<template>
  <v-dialog persistent v-model="dialog" width="900" scrollable>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Action Results - {{ results.length }} out of {{ total }}
        <v-spacer />
        <v-icon
          large
          style="color: red"
          :disabled="!stop"
          @click="dialog = false"
        >
          cancel
        </v-icon>
      </v-card-title>
      <v-card-text style="height: 100vh">
        <v-data-table
          :items="results"
          class="elevation-1"
          hide-actions
          hide-headers
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.id }}</td>
            <td class="text-xs-left">{{ props.item.dasher_name }}</td>

            <td class="text-xs-center" v-if="props.item.loading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </td>
            <td class="text-xs-center" v-else-if="props.item.error">
              <v-chip color="red" text-color="white">
                {{ props.item.errorStatusMsg }}
              </v-chip>
            </td>
            <td class="text-xs-center" v-else>
              <v-chip color="green" text-color="white">Success</v-chip>
            </td>

            <td class="text-xs-left">{{ props.item.errorMsg }}</td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn class="error" :disabled="stop" @click="$emit('stopAction')">
          Stop
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: ["value", "results", "stop", "total"],
    data() {
      return {
        dialog: this.value,
        disabled: false,
      };
    },
    watch: {
      dialog() {
        this.$emit("input", this.dialog);
      },
      value() {
        this.dialog = this.value;
      },
    },
  };
</script>
